import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  TableCellAttribute,
  TableCellOnActionEvent,
  TableCellStyles,
  TableData,
} from '../../../interfaces/tables.interfaces';

@Component({
  exportAs: 'dynamicTable',
  selector: 'table-constructor',
  templateUrl: './table-constructor.component.html',
  styleUrls: ['./table-constructor.component.scss'],
})
export class TableConstructorComponent {
  @Input({ required: true }) public tableData: TableData;
  @Input({ required: true }) public tableCellAttributes: TableCellAttribute[];
  @Input({ required: true }) public tableCellStyles: TableCellStyles;
  @Input({ required: true }) public customTableStyle: string;

  @Input({ required: false }) public redirectToLoginIfNoSession = false;
  @Input({ required: false }) public isExpired = false;

  @Output() public action: EventEmitter<TableCellOnActionEvent> = new EventEmitter<TableCellOnActionEvent>();

  public onAction(event: TableCellOnActionEvent): void {
    this.action.emit(event);
  }
}
